export class CreateRemoteDatabaseAccessDto {
    constructor(public DatabaseId: number, public UserId: number, public RemoteUserName: string) {
    }
}